export default __webpack_public_path__ + "static/media/frame_ko_sp-landscape.3c026cd6.png";